import { defineStore } from 'pinia'

export const useAdminDataStore = defineStore('admin', {
  state: () => {
    return { 
      authToken: '',
      authTokenGeneratedAtTimestamp: null,
      adminLastActiveIndex: 0,

      newsletterRecipients: [],
      newsletterRecipientsAreLoading: false,

      foodMenuClients: [],
      foodMenuClientsAreLoading: false,

      foodIngredients: [],
      foodIngredientsAreLoading: false,

      foodMenuItems: [],
      foodMenuItemsAreLoading: false,

      foodMenuOrders: [],
      foodMenuOrdersAreLoading: false,

      orderDiscountRules: [],
      orderDiscountRulesAreLoading: false,

      foodRecipes: [],
      foodRecipesAreLoading: false,

      addIngredientName: '',
      addIngredientUniverse: '',
      addIngredientPopinDisplayed: false,
      editedIngredient: null,

      editedOrderDiscountRule: null,
      addOrderDiscountRulePopinDisplayed: false,

      editedFoodMenuClient: null,
      addFoodMenuClientPopinDisplayed: false,
      
      popinPicturePickerDisplayed: false,
      popinPicturePickerSelectedPicture: '',


      addRecipePopinDisplayed: false,
      editedRecipe: null,
      editedRecipeOnlyShow: null,

      justAddedIngredient: null,
      justAddedOrderDiscountRule: null,
      justSavedRecipe: null,

      popinFormIsEdited: false,

      menuCustomersAreLoading: false,
      menuCustomers: [],
      keyShortcutSignal: 0,

      recipesToUpdatePrice: [],
      recipesToUpdatePriceToProcessTotalCount: 0,
      recipesToUpdatePriceProcessedCount: 0,

      recipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice: false,

      
      recipesToLoadDetail: [],
      recipesToLoadDetailToProcessTotalCount: 0,
      recipesToLoadDetailProcessedCount: 0,
    }
  },
  getters:{
    isAuthenticated: (state) => (!!(state.authToken) && ((new Date().getTime() / 1000) - state.authTokenGeneratedAtTimestamp) < 3600 * 12),
    isSuperAdmin: () => {
      const email = `${localStorage.getItem('loginUsername')}`.toLocaleLowerCase();
      return email == 'simon.minotto@gmail.com' || email == 'sophie.minotto.pro@gmail.com' || email == 'sophie@miam-vercors.com';
    },
  },
  actions: {
    setAuthToken(token, authTokenGeneratedAtTimestamp = null) {
      if(authTokenGeneratedAtTimestamp == null) {
        authTokenGeneratedAtTimestamp = Math.round((new Date().getTime() / 1000));
      }
      this.authToken = token;
      this.authTokenGeneratedAtTimestamp = authTokenGeneratedAtTimestamp;
    },    
    logout() {
      this.authToken = null;
      this.authTokenGeneratedAtTimestamp = null;
    },
    setAdminLastActiveIndex(index) {
      this.adminLastActiveIndex = index;
    },
    
    setNewsletterRecipients(newsletterRecipients) {
      this.newsletterRecipients = newsletterRecipients;
      this.newsletterRecipientsAreLoading = false;
    },
    setNewsletterRecipientsAreLoading(loading = true) {
      this.newsletterRecipientsAreLoading = loading;
    },
    setFoodMenuClients(foodMenuClients) {
      this.foodMenuClients = foodMenuClients;
      this.foodMenuClientsAreLoading = false;
    },
    setFoodMenuClientsAreLoading(loading = true) {
      this.foodMenuClientsAreLoading = loading;
    },
    setMenuCustomersAreLoading(loading = true) {
      this.menuCustomersAreLoading = loading;
    },
    setMenuCustomers(customers) {
      this.menuCustomers = customers;
      this.menuCustomersAreLoading = false;
    },    
    setFoodIngredients(foodIngredients) {
      this.foodIngredients = foodIngredients;
      this.foodIngredientsAreLoading = false;
    },
    setPopinPicturePickerDisplayed(popinPicturePickerDisplayed) {
      this.popinPicturePickerDisplayed = popinPicturePickerDisplayed;
    },
    setPopinPicturePickerSelectedPicture(url) {
      this.popinPicturePickerSelectedPicture = url;
    },
    setFoodIngredientsAreLoading(loading = true) {
      this.foodIngredientsAreLoading = loading;
    },
    setFoodMenuItems(foodMenuItems) {
      this.foodMenuItems = foodMenuItems;
      this.foodMenuItemsAreLoading = false;
    },
    setFoodMenuItemsAreLoading(loading = true) {
      this.foodMenuItemsAreLoading = loading;
    },
    setFoodMenuOrders(foodMenuOrders) {
      this.foodMenuOrders = foodMenuOrders;
      this.foodMenuOrdersAreLoading = false;
    },
    setFoodMenuOrdersAreLoading(loading = true) {
      this.foodMenuOrdersAreLoading = loading;
    },
    
    setOrderDiscountRules(orderDiscountRules) {
      this.orderDiscountRules = orderDiscountRules;
      this.orderDiscountRulesAreLoading = false;
    },
    setOrderDiscountRulesAreLoading(loading = true) {
      this.orderDiscountRulesAreLoading = loading;
    },
    setFoodRecipes(foodRecipes) {
      // pour ne pas perdre un détail de recette chargé par exemple
      const localFoodRecipes = [...this.foodRecipes];
      
      foodRecipes.forEach((foodRecipe) => {
        const ix = localFoodRecipes.findIndex((r => r.id == foodRecipe.id));
        if(ix >= 0) {
          localFoodRecipes[ix] = {...localFoodRecipes[ix], ...foodRecipe};
        }else{
          localFoodRecipes.push(foodRecipe);
        }
      });

      this.foodRecipes = localFoodRecipes;      
      this.foodRecipesAreLoading = false;
    },
    deleteAFoodRecipe(id) {
      this.foodRecipes = this.foodRecipes.filter(f => f.id != id);
    },
    refreshFoodRecipe(foodRecipe) {      
      const ix = this.foodRecipes.findIndex((r => r.id == foodRecipe.id));
      if(ix >= 0) {
        this.foodRecipes[ix] = {...this.foodRecipes[ix], ...foodRecipe};
      }else{
        this.foodRecipes = [foodRecipe, ...this.foodRecipes];
      }
      //this.foodRecipes = [...this.foodRecipes];
    },
    setFoodRecipe(id, foodRecipe) {
      var ix = this.foodRecipes.findIndex(r => r.id == id);
      if(ix >= 0) {
        this.foodRecipes[ix] = foodRecipe;
      }else{
        this.foodRecipes = [...this.foodRecipes, foodRecipe];
      }
    },
    setFoodMenuItem(id, foodMenuItem) {
      var ix = this.foodMenuItems.findIndex(r => r.id == id);
      if(ix >= 0) {
        this.foodMenuItems[ix] = foodMenuItem;
      }else{
        this.foodMenuItems = [...this.foodMenuItems, foodMenuItem];
      }
    },
    setFoodRecipeIngredient(id, foodRecipeIngredient) {
      var ix = this.foodRecipeIngredients.findIndex(r => r.id == id);
      if(ix >= 0) {
        this.foodRecipeIngredients[ix] = foodRecipeIngredient;
      }else{
        this.foodRecipeIngredients = [...this.foodRecipeIngredients, foodRecipeIngredient];
      }
    },
    refreshFoodIngredient(foodIngredient) {
      const ix = this.foodIngredients.findIndex((r => r.id == foodIngredient.id));
      if(ix >= 0) {
        this.foodIngredients[ix] = {...foodIngredient};
      }else{
        this.foodIngredients = [foodIngredient, ...this.foodIngredients];
      }
      //this.foodRecipes = [...this.foodRecipes];
    },
    setFoodIngredient(id, foodIngredient) {
      var ix = this.foodIngredients.findIndex(r => r.id == id);
      if(ix >= 0) {
        this.foodIngredients[ix] = foodIngredient;
      }else{
        this.foodIngredients = [...this.foodIngredients, foodIngredient];
      }
    },
    setFoodRecipesAreLoading(loading = true) {
      this.foodRecipesAreLoading = loading;
    },
    
    displayAddIngredientPopin(ingredientName) {
      this.editedIngredient = null;
      this.addIngredientPopinDisplayed = true;
      this.addIngredientName = ingredientName;
    },
    hideAddIngredientPopin() {
      this.addIngredientPopinDisplayed = false;
    },

    displayAddOrderDiscountRulePopin() {
      this.editedOrderDiscountRule = null;
      this.addOrderDiscountRulePopinDisplayed = true;
    },
    hideAddOrderDiscountRulePopin() {
      this.addOrderDiscountRulePopinDisplayed = false;
    },
    displayAddFoodMenuClientPopin() {
      this.editedFoodMenuClient = null;
      this.addFoodMenuClientPopinDisplayed = true;
    },
    hideAddFoodMenuClientPopin() {
      this.addFoodMenuClientPopinDisplayed = false;
    },
    
    displayEditIngredientPopin(editedIngredient) {
      this.editedIngredient = editedIngredient;
      this.addIngredientPopinDisplayed = true;
    },
    displayEditOrderDiscountRulePopin(orderDiscountRule) {
      this.editedOrderDiscountRule = orderDiscountRule;
      this.addOrderDiscountRulePopinDisplayed = true;
    },
    displayEditFoodMenuClientPopin(foodMenuClient) {
      this.editedFoodMenuClient = foodMenuClient;
      this.addFoodMenuClientPopinDisplayed = true;
    },

    
    displayAddRecipePopin() {
      this.editedRecipe = null;
      this.addRecipePopinDisplayed = true;
      this.editedRecipeOnlyShow = false;
    },
    hideAddRecipePopin() {
      this.editedRecipe = null;
      this.addRecipePopinDisplayed = false;
    },
    
    setToEditRecipe(editedRecipe) {
      this.editedRecipe = editedRecipe;
    },
    
    displayEditRecipePopin(editedRecipe) {
      this.editedRecipe = editedRecipe;
      this.editedRecipeOnlyShow = false;
      this.addRecipePopinDisplayed = true;
    },

    displayShowRecipePopin(editedRecipe) {
      this.editedRecipe = editedRecipe;
      this.editedRecipeOnlyShow = true;
      this.addRecipePopinDisplayed = true;
    },

    setJustAddedIngredient(justAddedIngredient) {
      this.justAddedIngredient = justAddedIngredient;
    },
    setJustAddedOrderDiscountRule(orderDiscountRule) {
      this.justAddedOrderDiscountRule = orderDiscountRule;
    },
    setPopinFormIsEdited(popinFormIsEdited) {
      this.popinFormIsEdited = popinFormIsEdited;
    },

    setJustSavedRecipe(justSavedRecipe) {
      this.justSavedRecipe = justSavedRecipe;
      if(justSavedRecipe) {
        const ix = this.foodRecipes.findIndex((r) => r.id == justSavedRecipe.id);
        if(ix >= 0) {
          this.foodRecipes[ix] = justSavedRecipe;
        }
      }
    },
    setRecipesToUpdatePrice(recipeIds) {      
      let countBefore = this.recipesToUpdatePrice.length;
      this.recipesToUpdatePrice = [...new Set([...this.recipesToUpdatePrice, ...recipeIds])];
      let countAfter = this.recipesToUpdatePrice.length;
      
      // car on ajoute des elements qui était déjà présents, on ne remet pas le processedCount à zéro, donc il faut dire combien on en a ajouté de +
      // this.recipesToUpdatePriceToProcessTotalCount = this.recipesToUpdatePrice.length;
      this.recipesToUpdatePriceToProcessTotalCount += (countAfter - countBefore);
    },
    incrementRecipesToUpdatePriceProcessedCount() {
      this.recipesToUpdatePriceProcessedCount = this.recipesToUpdatePriceProcessedCount + 1;
    },
    setRecipesToUpdatePriceProcessed(foodRecipeId) {
      this.recipesToUpdatePrice = this.recipesToUpdatePrice.filter(e => e != foodRecipeId);
    },
    resetToUpdatePrices() {
      this.recipesToUpdatePrice = [];
      this.recipesToUpdatePriceProcessedCount = 0;
      this.recipesToUpdatePriceToProcessTotalCount = 0;
    },

    
    setRecipesToLoadDetail(recipeIds) {      
      let countBefore = this.recipesToLoadDetail.length;
      this.recipesToLoadDetail = [...new Set([...this.recipesToLoadDetail, ...recipeIds])];
      let countAfter = this.recipesToLoadDetail.length;
      
      // car on ajoute des elements qui était déjà présents, on ne remet pas le processedCount à zéro, donc il faut dire combien on en a ajouté de +
      // this.recipesToUpdatePriceToProcessTotalCount = this.recipesToUpdatePrice.length;
      this.recipesToLoadDetailToProcessTotalCount += (countAfter - countBefore);
    },
    incrementRecipesToLoadDetailProcessedCount() {
      this.recipesToLoadDetailProcessedCount = this.recipesToLoadDetailProcessedCount + 1;
    },
    setRecipesToLoadDetailProcessed(foodRecipeId) {
      this.recipesToLoadDetail = this.recipesToLoadDetail.filter(e => e != foodRecipeId);
    },

    resetRecipeToLoadDetail() { 
      this.recipesToLoadDetail = [];
      this.recipesToLoadDetailProcessedCount = 0;
      this.recipesToLoadDetailToProcessTotalCount = 0;
    },
    
    notifyCanRebindKeyShortcut() {
      this.keyShortcutSignal++;
    },

    setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(v) {
      this.recipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice = v;
    },
    
    
  },
})